function initWorkforceSteps() {
    const section = document.querySelector('.steps-section');
    if (!section) return;

    // Avoid binding twice (Turbo etc.)
    if (section.dataset.stepsBound === '1') return;
    section.dataset.stepsBound = '1';

    // Enable animation layer
    document.body.classList.add('motion-ready');

    const heading = section.querySelector('.js-steps-heading');
    const cards   = section.querySelectorAll('.js-steps-card');
    const bottoms = section.querySelectorAll('.js-steps-bottom');

    if (!heading && cards.length === 0 && bottoms.length === 0) return;

    const allEls = [];
    if (heading) allEls.push(heading);
    cards.forEach(c => allEls.push(c));
    bottoms.forEach(b => allEls.push(b));

    // No IO? Just show everything (no animation, but no broken layout)
    if (!('IntersectionObserver' in window)) {
        allEls.forEach(el => el.classList.add('is-visible'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0];
            if (!entry) return;

            const inView  = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            const outView = !entry.isIntersecting || entry.intersectionRatio < 0.05;

            if (inView) {
                // Animate everything in (CSS handles stagger)
                allEls.forEach(el => el.classList.add('is-visible'));
            } else if (outView) {
                // Allow replay when scrolling back up
                allEls.forEach(el => el.classList.remove('is-visible'));
            }
        },
        {
            threshold: [0, 0.05, 0.2, 0.6],
            rootMargin: '0px 0px -10% 0px'
        }
    );

    observer.observe(section);
}

// Plain DOM + Turbo
document.addEventListener('DOMContentLoaded', initWorkforceSteps);
document.addEventListener('turbo:load', initWorkforceSteps);